import script from "./OverviewTab.vue?vue&type=script&setup=true&lang=js"
export * from "./OverviewTab.vue?vue&type=script&setup=true&lang=js"

import "./OverviewTab.vue?vue&type=style&index=0&id=210cf39a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-210cf39a"]])

export default __exports__